﻿import { SubDialogHelper, Widget, DataChangeInfo } from "@serenity-is/corelib";

SubDialogHelper.bindToDataChange = (dialog: any, owner: Widget<any>,
    dataChange: (p1: any, p2: DataChangeInfo) => void, useTimeout?: boolean) => {
    var widgetName = (owner as any).widgetName;
    dialog.element.bind('ondatachange.' + widgetName, function (e: JQueryEventObject, dci: any) {
        if (useTimeout) {
            window.setTimeout(function () {
                dataChange(e, dci);
            }, 0);
        }
        else {
            dataChange(e, dci);
        }
    }).bind('remove.' + widgetName, function () {
        dialog?.element?.unbind('ondatachange.' + widgetName);
    });
    return dialog;
}